import themeConfig from "./whitelabel-infos";
import { IWhiteLabelInfos } from "./whitelabel-infos.interface";

class WhitelabelService {
  // Tenant pelo subdomínio; fora de um domínio de tenant (localhost, CloudFront de staging),
  // pelo REACT_APP_API_TOKEN do build. Sem nenhum dos dois, não há tenant.
  private resolveTenant(): IWhiteLabelInfos | undefined {
    const { host } = window.location;
    const subdomain = host.split('.')[0];

    const bySubdomain = themeConfig.find(item => item.workspace === subdomain);
    if (bySubdomain) {
      return bySubdomain;
    }

    const apiToken = process.env.REACT_APP_API_TOKEN;

    return apiToken ? themeConfig.find(item => item.api === apiToken) : undefined;
  }

  public getWBDataCompany(): IWhiteLabelInfos {
    return this.resolveTenant() || themeConfig[1];
  }
}
export default new WhitelabelService();
